<template>             
	<template v-for="(item, index) in campos" :key="index">  
        <div :class="`col-12 col-sm-${item.sm} col-lg-${item.lg} col-xxl-${item.xxl ?? ''}`">  
            
            <div class="form-check form-check-custom form-check-solid" v-if="item.type =='checkbox'">
                <input  class="form-contro form-check-input" type="checkbox" v-model="formulario[item.nome]"   :name="item.nome"  :disabled="item.disabled || disabled"> 
                <label class="form-check-label" for="flexCheckDefault">{{item.label}}</label>
            </div>

            <div class="form-group" v-if="item.type !='checkbox'"> 

                <label for="descricao" class="form-check-label">{{item.label}}:</label>  

                <input v-if="item.type =='text' || item.type =='number' || item.type =='date' || item.type =='time' " required :type="item.type"    :name="item.nome" class="form-control" v-model="formulario[item.nome]" :disabled="item.disabled || disabled"> 

                <Multiselect  v-if="item.type =='select' "  v-model="formulario[item.nome]" :options="item.options" :searchable="true" :disabled="item.disabled || disabled" ></Multiselect>   

                <Multiselect v-if="item.type =='selectajax'" v-model="formulario[item.nome]"  :filterResults="false" :minChars="3" :resolveOnLoad="true" :delay="500" :searchable="true" :options=" async function(query) { return await buscarPublicaco( query , item.api)}" noOptionsText="Nenhum item encontrado"  :disabled="item.disabled || disabled"/>
                 
                <textarea v-if="item.type =='textarea'" :rows="item.rows ?? 1" required  :name="item.nome" class="form-control" v-model="formulario[item.nome]" :disabled="item.disabled || disabled"> </textarea>

            </div>
        </div> 
    </template>
</template>


<script lang="ts"> 
    import { Prop } from 'vue-property-decorator';  
    import { Options, Vue  } from "vue-class-component";   
     
    import Multiselect from '@vueform/multiselect'

    @Options({
        name: "ListaCampoForm",
        components: {  Multiselect },  
    }) 
    export default class  ListaCampoForm extends Vue {  
        
        @Prop( ) readonly campos!: any  
        @Prop( ) readonly formulario!: any  
        @Prop( ) readonly disabled!: any  

        
        public async  buscarPublicaco( query , api ){
            if(query){
                const response =  await api.service[api.method]( query );
                return response.data.map((item) => {
                    const label = typeof api.label === 'function' ? api.label(item) : item[api.label];
                    return { value: item[api.id], label }
                })
            }
        }

    } 
</script>


<style>  
    @media screen and (max-width: 600px) { 
        .multiselect>* {
            font-size: small; 
        } 
        .multiselect-multiple-label, .multiselect-placeholder, .multiselect-single-label { 
            min-width: 90%; 
            padding-left: 7px;
            position: relative; 
        } 
        .multiselect-option { 
            min-height: 50px !important; 
        } 
    } 
</style> 

